import React from 'react';
import { DashboardToolCard } from 'apps/sigma2-ui/src/components/overview/DashboardToolCard';
import { DashboardToolCardProps } from 'apps/sigma2-ui/src/components/overview/DashboardToolCard';
import cn from 'classnames';

export type DashboardToolCardPropsWithoutVariant = Omit<
  DashboardToolCardProps,
  'variant'
>;

export interface DashboardToolCardGridProps {
  /**
   * The cards to display.
   */
  cards: DashboardToolCardPropsWithoutVariant[];
}

export const DashboardToolCardGrid = ({
  cards,
}: DashboardToolCardGridProps) => {
  const variant = cards.length > 4 ? '3-col' : '2-col';

  return (
    <div
      className={cn('grid gap-6', {
        'grid-cols-2': variant === '2-col',
        'grid-cols-3': variant === '3-col',
      })}
    >
      {cards.map((card, index) => (
        <DashboardToolCard {...card} variant={variant} key={index} />
      ))}
    </div>
  );
};
